<!--
 * @Author: your name
 * @Date: 2021-08-27 10:08:53
 * @LastEditTime: 2024-08-05 16:08:40
 * @LastEditors: Ant🐜
 * @Description: In User Settings Edit
 * @FilePath: \h5\src\views\Yck\components\WalletItem.vue
-->
<template>
  <div class="bonusOne">
    <div class="bonusInfo">
      <div class="bonus-row mb4">
        <span class="row-txt">{{ item.detail_title }}</span
        ><span :class="{ 'row-money': true, 'row-moneyfu': item.inoutType == -1 }"
          ><i style="margin-right: 3px">{{ item.inoutType == -1 ? '-' : '+' }}</i
          >¥{{ item.amount }}</span
        >
      </div>
      <div class="bonus-row">
        <span class="row-subTxt"
          >{{ item.bizSn ? item.bizSn : item.orderSn }}
          <span
            v-if="item.bizSn ? item.bizSn : item.orderSn"
            class="copy"
            @click="copyLink(item.bizSn ? item.bizSn : item.orderSn)"
            >复制</span
          ></span
        >
      </div>
      <div class="bonus-row">
        <span class="row-subTxt">{{ item.createdDate }}</span>
      </div>
      <div class="bonus-row">
        <span class="row-subTxt">备注：{{ item.remark }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { nextTick, unref } from 'vue'
import { useCopyToClipboard } from '@/hooks/useCopyToClipboard'
import { Toast } from '@vant/compat'

export default {
  props: {
    item: Object
  },
  setup() {
    nextTick(() => {})
    const { clipboardRef, copiedRef } = useCopyToClipboard()
    const copyLink = orderSn => {
      clipboardRef.value = orderSn
      unref(copiedRef) && Toast.success('复制成功')
    }
    return { copyLink }
  }
}
</script>

<style lang="less" scoped>
.bonusOne {
  background: #fff;
  padding: 0 15px;
  overflow: hidden;
  border-bottom: 1px solid #dbdbdb;
  &:last-child {
    border-bottom: none;
  }
  .bonusInfo {
    padding: 12px 0 10px;
  }

  .bonus-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .row-txt {
      font-size: 16px;
      color: #222;
      font-weight: bold;
      line-height: 22px;
    }
    .row-money {
      color: #ff6060;
      line-height: 22px;
      font-weight: bold;
      font-size: 14px;
      > i {
        font-style: normal;
      }
    }
    .row-moneyfu {
      color: #2f3032;
    }

    .row-subTxt {
      color: #999999;
      line-height: 20px;
      font-size: 14px;
      margin-bottom: 2px;
    }
    .row-subStatus {
      color: #999999;
      line-height: 20px;
      font-size: 14px;
    }
  }
  .mb4 {
    margin-bottom: 4px;
  }
}
.copy {
  font-size: 12px;
  color: #ff6060;
}
</style>
